import React from 'react';
import { AppStore } from '../../AppStore';
import { MorphologyStore } from '../_puzzles/Morphology/MorphologyStore';
import MorphologyCover from 'url:./assets/morphologyIcon.png';
import OutcomeBanner from './OutcomeBanner';

const MorphologyPreview = ({ onClick }: { onClick: () => void }) => {
  const puzzleData = AppStore.useState(s => s.puzzleData?.morphology);
  if (!puzzleData) return null;

  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="morphologyPreview">
        <div className="shadedContainer">
          <div className="puzzleTitle">{puzzleData.cryptic ? 'Cryptic Morphology' : 'Morphology'}</div>
          {puzzleData.themeless && <div className="nextPuzzleNote">(Themeless)</div>}
          <img className="morphologyIcon" src={MorphologyCover}/>
          <div className="authorInfo">
            <div className="byline">By</div>
            <div className="author">{puzzleData.author || 'Anonymous'}</div>
          </div>
          <OutcomeBanner store={MorphologyStore as any}/>
        </div>
      </div>
    </div>
  );
};

export default MorphologyPreview;